import angular from "angular";
import uiRouter from "angular-ui-router";

import LoginComponent from "./login.component";
import LoginAuthController from "./login.auth.controller";

/*@ngInject*/
const login = angular
    .module("app.login",[uiRouter])
    .config($stateProvider=>{
        "ngInject";
        $stateProvider
            .state('login',{
                url:'/login',
                component:'loginComponent',
            })
            .state('loginAuth',{
                url:'/login/:data',
                controller:'loginAuthController',
                template:require("./loginLocked.template.html"),
                controllerAs:'$ctrl'
            });
    })
    .controller('loginAuthController',LoginAuthController)
    .component('loginComponent',LoginComponent)
    .name;

export default login;


// WEBPACK FOOTER //
// ./public/app/login/index.js